import React, {useEffect} from "react";
import {observer} from "mobx-react";
import dashboardSettingsStore from "../../../stores/dashboard-settings-store";
import AppHeader from "./app-header/app-header";
import AppSidebar from "./app-sidebar/app-sidebar";
import PageUrlCoordinator from "./page-url-broadcaster/page-url-coordinator";
import PageViewTracker from "./page-view-tracker/page-view-tracker";
import PlanApprovalModalGate from "./plan-approval-modal-gate/plan-approval-modal-gate";
import TermsAcceptanceModalGate from "./terms-acceptance-modal-gate/terms-acceptance-modal-gate";
import { usePlanApprovalSuccessToast } from "../../../pages/home/components/plan-approval-modal/hooks/use-plan-approval-success-toast";

import './app-layout.scss';

interface IAppLayoutProps {
    children?: React.ReactNode;
}

const AppLayout: React.FC<IAppLayoutProps> = observer(({ children }) => {
    usePlanApprovalSuccessToast();

    useEffect(() => {
        dashboardSettingsStore.load();
    }, []);

    if (!dashboardSettingsStore.showHeaderAndSidebar) {
        return (
            <>
                <PageViewTracker />
                <TermsAcceptanceModalGate />
                <PlanApprovalModalGate />
                {children}
            </>
        );
    }

    return (
        <div className="app-layout">
            <PageUrlCoordinator />
            <PageViewTracker />
            <TermsAcceptanceModalGate />
            <PlanApprovalModalGate />
            <AppHeader />
            <AppSidebar />
            {children}
        </div>
    )
})

export default  AppLayout;
